import React from 'react';
import * as ReactDOM from "react-dom";
import Game from "../Game";
import {withRouter} from "../withRouter";
import {NavLink} from "react-router-dom";
import {format} from "react-string-format";
import {Col, Container, Row} from "react-bootstrap";

class AdminPayouts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            isLoadedData: false,
            error: null,
            adminData: [],
            userId: null,
            loginError: null,
            payoutsApproved: null,
            payoutsApprovedIsLoaded: false,
            payoutsInReview: null,
            payoutsInReviewIsLoaded: false,
        };
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + '/my-account/try-login-via-cache', {
            method: "POST",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
                (result) => {
                    if (result.role.name !== 'admin') {
                        this.setState({
                            isLoaded: true,
                            loginError: 'unauthorized'
                        });
                    } else {
                        this.setState({
                            isLoaded: true,
                            userId: result.id
                        });

                        fetch(process.env.REACT_APP_API_URL + "/admin/" + result.id.toString(), {
                            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
                        })
                            .then(res => res.json())
                            .then(
                                (result) => {
                                    this.setState({
                                        isLoadedData: true,
                                        adminData: result
                                    });
                                },

                                (error) => {
                                    this.setState({
                                        isLoadedData: true,
                                        error
                                    });
                                }
                            )

                        fetch(process.env.REACT_APP_API_URL + "/payouts?status=in_review", {
                            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
                        })
                            .then(res => res.json())
                            .then(
                                (result) => {
                                    this.setState({
                                        payoutsInReviewIsLoaded: true,
                                        payoutsInReview: result
                                    });
                                },

                                (error) => {
                                    this.setState({
                                        payoutsInReviewIsLoaded: true,
                                        error
                                    });
                                }
                            )

                        fetch(process.env.REACT_APP_API_URL + "/payouts?status=confirmed", {
                            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
                        })
                            .then(res => res.json())
                            .then(
                                (result) => {
                                    this.setState({
                                        payoutsApprovedIsLoaded: true,
                                        payoutsApproved: result
                                    });
                                },

                                (error) => {
                                    this.setState({
                                        payoutsApprovedIsLoaded: true,
                                        error
                                    });
                                }
                            )
                    }
                },
                (error) => {
                    this.setState({
                        isLoaded: false,
                        loginError: "unauthorized",
                    });
                }
            );
    }

    approvePayout(e){
        e.preventDefault();

        this.setState({
            payoutsInReviewIsLoaded: false
        });

        fetch(process.env.REACT_APP_API_URL + "/payouts/"+e.target.id.value+"/approve", {
            method: "POST",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(
                (result) => {
                    this.componentDidMount()

                    this.setState({
                        payoutsInReviewIsLoaded: true
                    });
                },

                (error) => {
                    console.log(error);

                    this.componentDidMount()

                    this.setState({
                        payoutsInReviewIsLoaded: true
                    });
                }
            )
    }

    render() {
        const { payoutsApproved, payoutsInReview, payoutsApprovedIsLoaded, payoutsInReviewIsLoaded, isLoaded, isLoadedData, adminData, loginError} = this.state;

        const { navigate } = this.props;

        let payoutsInReviewFormatted = "Loading...";
        let payoutsApprovedFormatted = "Loading...";

        if (payoutsInReviewIsLoaded && payoutsInReview.length>0){
            payoutsInReviewFormatted = <div>
                <h1>Needs review</h1>
                {payoutsInReview.map(item => (
                    <div class={item.status==='in_review' ? "alert alert-warning" : "alert alert-success"}>
                        ${item.amount}
                        <br/>
                        {item.created_at}
                        <br/>
                        <a href={"/customer/" + item.user.id}>{item.user.email}</a>
                        <br/>
                        {item.status==='in_review' ? "In review" : "Confirmed"}
                        <div>
                            {item.user.user_payment_card.map(item2 => (
                                item2.is_default ? <div>
                                    {item2.number}
                                    <br/>
                                    {item2.address.country}, {item2.address.state}, {item2.address.city}
                                    <br/>
                                    {item2.address.line1}
                                    <br/>
                                    {item2.address.postal_code}
                                </div> : <br/>
                            ))}
                        </div>
                        <form onSubmit={this.approvePayout.bind(this)}>
                            <input type="number" name="id" hidden value={item.id}/>
                            <input type="submit" value="Approve" className="btn btn-success"/>
                        </form>
                    </div>
                ))}
            </div>
        }else if(payoutsInReviewIsLoaded && payoutsInReview.length===0){
            payoutsInReviewFormatted=null;
        }

        if (payoutsApprovedIsLoaded && payoutsApproved.length>0){
            payoutsApprovedFormatted = <div>
                <h1>Recently confirmed</h1>
                {payoutsApproved.map(item => (
                    <div class={item.status==='in_review' ? "alert alert-warning" : "alert alert-success"}>
                        ${item.amount}
                        <br/>
                        {item.created_at}
                        <br/>
                        {item.status==='in_review' ? "In review" : "Confirmed"}
                        <br/>
                        <a href={"/customer/" + item.user.id}>{item.user.email}</a>
                        <ul>
                        {item.user.user_payment_card.map(item => (
                            <li>{item.number} {item.is_default ? " - Prioritized": ""}</li>
                        ))}
                        </ul>
                        <form>
                            <input hidden type="number" name="id" value={item.id}/>
                        </form>
                        <br/>
                        <NavLink className={"btn btn-outline-dark"} to={{
                            pathname: item.id.toString(),
                        }}>
                            Open
                        </NavLink>
                    </div>
                ))}
            </div>
        } else if(payoutsApprovedIsLoaded && payoutsApproved.length===0){
            payoutsApprovedFormatted=null;
        }

        if (loginError) {
            navigate('/account');
        }

        return <Container>
            <Row>
                <Col>
                    {payoutsInReviewFormatted}{payoutsApprovedFormatted}
                </Col>
            </Row>
        </Container>
    }
}

export default withRouter(AdminPayouts);
